@if (loading) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
}

@if (construct.source.data.length === 0 && !loading) {
  <mat-card>
    <mat-card-content>
      <div class="empty-table">
        <mat-icon>info</mat-icon>
        <p>No records found</p>
      </div>
    </mat-card-content>
  </mat-card>
}

@if (construct.source.data.length > 0 && !loading) {
  <div class="table">
    @if (construct.settings.sort?.enabled) {
      <table
        mat-table
        #sortTable
        [dataSource]="construct.source"
        matSort
        [matSortActive]="construct.settings.sort?.defaultColumn || construct.displayedColumns[0]"
        [matSortDirection]="construct.settings.sort?.direction || 'asc'">
        @for (def of construct.columns; track def; let i = $index) {
          <ng-container [matColumnDef]="def.field">
            <mat-header-cell *matHeaderCellDef mat-sort-header [sortActionDescription]="'Sort by ' + def.header">
              <div class="table-header">{{ def.header }}</div>
            </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <!-- Define the fallback template first -->
              <!-- Now use the fallback template -->
              @if (def.cellTemplate) {
                <ng-container *ngTemplateOutlet="def.cellTemplate; context: {$implicit: element}"></ng-container>
              } @else {
                @if (def.actions == undefined || def.actions.length === 0) {
                  @if (!def.format) {
                    <span>{{ element[def.field] }}</span>
                  }
                  @if (def.format === 'titlecase') {
                    <span>{{ element[def.field] | titlecase }}</span>
                  }
                  @if (def.format === 'currency') {
                    <span>{{ element[def.field] | currency }}</span>
                  }
                  @if (def.format === 'date') {
                    <span>{{ element[def.field] | date: 'MM/dd/yyyy' }}</span>
                  }
                  @if (def.format === 'phone') {
                    <span>{{ element[def.field] | phone }}</span>
                  }
                  @if (def.format === 'percent') {
                    <span>{{ element[def.field] | percent }}</span>
                  }
                  @if (def.format == 'status') {
                    <div [class]="element[def.field] | status">
                      {{ element[def.field] | titlecase }}
                    </div>
                  }
                }
                @if (def.actions != undefined && def.actions.length > 0) {
                  <app-table-actions [actions]="def.actions" [entity]="element"></app-table-actions>
                }
              }
            </mat-cell>
          </ng-container>
        }
        <mat-header-row *matHeaderRowDef="construct.displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: construct.displayedColumns;"></mat-row>
      </table>
    }
    @if (construct.settings.sort == undefined || !construct.settings.sort.enabled) {
      <table
        mat-table
        [dataSource]="construct.source"
        >
        @for (def of construct.columns; track def) {
          <ng-container [matColumnDef]="def.field">
            <mat-header-cell *matHeaderCellDef>
              <div class="table-header">{{ def.header }}</div>
            </mat-header-cell>
            <mat-cell *matCellDef="let element">
              @if (def.actions == undefined || def.actions.length === 0) {
                <div>
                  @if (!def.format) {
                    <span>{{ element[def.field] }}</span>
                  }
                  @if (def.format === 'titlecase') {
                    <span>{{ element[def.field] | titlecase }}</span>
                  }
                  @if (def.format === 'currency') {
                    <span>{{ element[def.field] | currency }}</span>
                  }
                  @if (def.format === 'date') {
                    <span>{{ element[def.field] | date: 'MM/dd/yyyy' }}</span>
                  }
                  @if (def.format === 'phone') {
                    <span>{{ element[def.field] | phone }}</span>
                  }
                  @if (def.format === 'percent') {
                    <span>{{ element[def.field] | percent }}</span>
                  }
                  @if (def.format == 'status') {
                    <span readonly [class]="element[def.field] | status">{{ element[def.field] | titlecase }}</span>
                  }
                </div>
              }
              @if (def.actions != undefined && def.actions.length > 0) {
                <app-table-actions [actions]="def.actions" [entity]="element"></app-table-actions>
              }
            </mat-cell>
          </ng-container>
        }
        <mat-header-row *matHeaderRowDef="construct.displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: construct.displayedColumns;"></mat-row>
      </table>
    }
    <!-- Pagination not currently on spec -->
    <!-- <mat-paginator
    [pageSizeOptions]="[5, 10, 25, 100]"
    [hidePageSize]="false"
    [showFirstLastButtons]="false"
  aria-label="Select page of data"></mat-paginator> -->
</div>
}